/**
 * @generated from enum qr_code.model.v1.QrCodeUrlTypeEnum
 */
export enum QrCodeUrlTypeEnum {
  /**
   * @generated from enum value: UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BOOK = 1;
   */
  BOOK = 1,

  /**
   * @generated from enum value: SUBJECT = 2;
   */
  SUBJECT = 2,

  /**
   * @generated from enum value: CHAPTER = 3;
   */
  CHAPTER = 3,

  /**
   * @generated from enum value: TOPIC = 4;
   */
  TOPIC = 4,

  /**
   * @generated from enum value: LESSON_PLAN = 5;
   */
  LESSON_PLAN = 5,

  /**
   * @generated from enum value: RESOURCE = 6;
   */
  RESOURCE = 6,

  /**
   * @generated from enum value: ASSESSMENT = 7;
   */
  ASSESSMENT = 7,
}
